var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "accordion", attrs: { id: "featureViewer" } },
        _vm._l(_vm.itemData, function (item, idx) {
          return _c("div", { key: `card-${idx}`, staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-header", attrs: { id: `heading-${idx}` } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block text-left z-depth-0",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": `#collapse-${idx}`,
                      "aria-expanded": idx == 0,
                      "aria-controls": `collapse-${idx}`,
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.name) +
                        "\n                    "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse",
                class: { show: idx == 0 },
                attrs: {
                  id: `collapse-${idx}`,
                  "aria-labelledby": `heading-${idx}`,
                  "data-parent": "#featureViewer",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-body p-0",
                    class: { "px-0": !item.name },
                  },
                  [
                    _c("group-element", {
                      attrs: { id: idx, item: item.items },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }